import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { UPDATES } from "@/data/mock";
import { FadeUp } from "@/components/shared/RevealText";

export default function LatestUpdates() {
    return (
        <section className="relative border-t border-ink/10 bg-white py-24 md:py-32" data-testid="latest-updates-section">
            <div className="container-x">
                <div className="mb-16 grid grid-cols-1 items-end gap-8 md:grid-cols-12">
                    <FadeUp className="md:col-span-7">
                        <div className="eyebrow mb-4">Ch. 07 · Latest updates</div>
                        <h2 className="h-display font-display text-[40px] font-black leading-[0.95] text-ink md:text-[64px]">
                            News from
                            <br />
                            the <span className="serif-italic text-pink">platform</span>.
                        </h2>
                    </FadeUp>
                    <FadeUp delay={0.1} className="md:col-span-5">
                        <p className="max-w-md text-[15px] leading-relaxed text-slate-600 md:text-[16px]">
                            Announcements, features and stories from the platform and its community. Illustrative
                            content for the concept.
                        </p>
                    </FadeUp>
                </div>

                <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
                    {UPDATES.map((u, i) => (
                        <motion.article
                            key={u.id}
                            initial={{ opacity: 0, y: 24 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.15 }}
                            transition={{ duration: 0.6, delay: (i % 3) * 0.06 }}
                            className="group flex flex-col overflow-hidden rounded-[22px] border border-ink/10 bg-white"
                            data-testid={`update-card-${u.id}`}
                        >
                            <div className="relative aspect-[16/10] overflow-hidden">
                                <img src={u.image} alt="" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" />
                                <span className="absolute left-4 top-4 rounded-full bg-white/90 px-3 py-1 text-[10px] font-semibold uppercase tracking-[0.24em] text-ink backdrop-blur">
                                    {u.tag}
                                </span>
                            </div>
                            <div className="flex flex-1 flex-col p-6">
                                <div className="text-[11px] font-semibold uppercase tracking-[0.24em] text-slate-400">
                                    {u.date}
                                </div>
                                <h3 className="mt-3 font-display text-[19px] font-semibold leading-snug tracking-tight text-ink group-hover:text-pink transition-colors">
                                    {u.title}
                                </h3>
                                <div className="mt-6 inline-flex items-center gap-1 text-[12px] font-semibold uppercase tracking-[0.22em] text-ink">
                                    Read <ArrowUpRight className="h-4 w-4" />
                                </div>
                            </div>
                        </motion.article>
                    ))}
                </div>
            </div>
        </section>
    );
}
